import React from "react";
import { Link } from "react-router-dom";
import YSVLogo from "@/components/YSVLogo";
import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" style={{
      borderTop: '1px solid var(--dark-border)',
      background: 'var(--dark-bg)',
      padding: '48px 24px 32px',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 40,
          marginBottom: 40,
        }}>
          {/* Brand */}
          <div>
            <Link to="/landing" style={{
              display: 'flex', alignItems: 'center', gap: 8,
              textDecoration: 'none', marginBottom: 12,
            }}>
              <YSVLogo size="sm" showSubtext />
            </Link>
            <p style={{ color: 'var(--text-secondary)', fontSize: 13, lineHeight: 1.6 }}>
              The complete video platform for youth football.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 style={{ fontSize: 13, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Platform</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: 'Features', path: '/features' },
                { label: 'Pricing', path: '/pricing' },
                { label: 'Support', path: '/support' },
              ].map(l => (
                <Link key={l.path} to={l.path} style={{
                  color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 14,
                  transition: 'color 0.2s',
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--cyan)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
                >{l.label}</Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 style={{ fontSize: 13, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Company</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { label: 'About', path: '/landing' },
                { label: 'Community', path: '/community' },
                { label: 'Careers', path: '/careers' },
                { label: 'Privacy Policy', path: '/support' },
                { label: 'Terms of Service', path: '/support' },
              ].map(l => (
                <Link key={l.label} to={l.path} data-testid={`footer-company-${l.label.toLowerCase().replace(/ /g, '-')}`} style={{
                  color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 14,
                  transition: 'color 0.2s',
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--cyan)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
                >{l.label}</Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: 13, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Contact</h4>
            <a href="mailto:info@ysvchi.com" data-testid="footer-email" style={{
              display: 'flex', alignItems: 'center', gap: 8,
              color: 'var(--cyan)', textDecoration: 'none', fontSize: 14, marginBottom: 12,
            }}>
              <Mail size={14} />
              info@ysvchi.com
            </a>
            <Link
              to="/permission"
              data-testid="footer-permission-link"
              style={{
                display: 'block',
                color: 'var(--text-secondary)', textDecoration: 'none', fontSize: 14,
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--cyan)'}
              onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}
            >
              Permission
            </Link>
          </div>
        </div>

        <div className="glow-line" style={{ marginBottom: 24 }} />
        
        <p data-testid="footer-copyright" style={{
          color: 'var(--text-secondary)',
          fontSize: 13,
          textAlign: 'center',
        }}>
          &copy; 2026 YSV - Youth Sports Video. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
